import type { FunctionComponent } from 'react';

import styles from './option_color_component.module.css';

type OptionProps = {
  option?: {
    label?: string;
    value?: string;
  };
};

const Option: FunctionComponent<OptionProps> = ({ option = {} }) => (
  <div className={styles.root}>
    <div className={styles.color} style={{ background: option.value }} />
  </div>
);

export default Option;
